import React, {useEffect, useRef,forwardRef, useImperativeHandle  } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
// import "./styles.css";
import MapViewToggleControl from "./MapViewToggleControl";

mapboxgl.accessToken =
  mapboxgl.accessToken ||
  "pk.eyJ1IjoiYWJoaWppdGgxMjc5IiwiYSI6ImNtNGNqdzE4NDA2MGoyaXFwdXh6cjVqMWQifQ.OpRKi-Zt3NIOjXFz-hd-DA";

// const ParcelMap = ({
//   parcelFile = "/assets/parcel/matched_fema_intersect.geojson",
//   parcels = [],
//   onLoaded = () => {},
//   showPoints = false,
//   setShowPoints = () => {},
//   onFeatureClick = () => {},
//   selectedFeature = null,
// },ref) => {
  const ParcelMap = forwardRef((props, ref) => {
  // Destructure props
  const {
    parcelFile = "/assets/parcel/matched_fema_intersect.geojson",
    parcels = [],
    onLoaded = () => {},
    showPoints = false,
    setShowPoints = () => {},
    onFeatureClick = () => {},
    selectedFeature = null,
  } = props;

  
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const toggleRef = useRef(null);
  const popupRef = useRef(null);
  // ✅ Make sure this is present
useImperativeHandle(ref, () => {
    console.log("ParcelMap: Exposing methods via ref"); // ✅ ADD: Debug log
    
    return {
        flyToLocation: (lng, lat, property) => {
            console.log("flyToLocation called:", { lng, lat, property }); // ✅ ADD: Debug log
            
            if (!mapRef.current) {
                console.warn("Map not initialized");
                return;
            }

            console.log("Map is initialized, flying to location..."); // ✅ ADD: Debug log

            // Close existing popups
            if (popupRef.current) {
                popupRef.current.remove();
                popupRef.current = null;
            }

            const existingPopups = document.getElementsByClassName('mapboxgl-popup');
            if (existingPopups.length) {
                Array.from(existingPopups).forEach(popup => popup.remove());
            }

            // Fly to location
            mapRef.current.flyTo({
                center: [lng, lat],
                zoom: 17,
                essential: true,
                duration: 1500,
                pitch: 0,
            });

            // Show popup
            const formatCurrency = (num) => num ? "$" + num.toLocaleString("en-US") : "N/A";

            popupRef.current = new mapboxgl.Popup({ 
                closeButton: true, 
                closeOnClick: true,
                offset: 25 
            })
                .setLngLat([lng, lat])
                .setHTML(`
                    <div style="
                        background:#fff;
                        padding:14px;
                        border-radius:8px;
                        box-shadow:0 2px 8px rgba(0,0,0,0.15);
                        font-family:Inter, sans-serif;
                        font-size:13px;
                        width:280px;
                    ">
                        <h3 style="margin:0 0 8px 0; color:#1565C0; font-size:15px; font-weight:600;">
                            ${property.addrline1 || property.address || property.parcel || "N/A"}
                        </h3>
                        <hr style="border:none; border-top:1px solid #eee; margin:8px 0;">
                        <p style="margin:4px 0; font-size:12px;">
                            <strong>Location:</strong> ${property.city || "N/A"}, ${property.county || "N/A"}, ${property.state || "N/A"} ${property.zip5 || ""}
                        </p>
                        <p style="margin:4px 0; font-size:12px;">
                            <strong>Flood Risk:</strong> ${property._floodRisk || property.FloodFemaRisk || property.FloodRisk || "N/A"}
                        </p>
                        <p style="margin:4px 0; font-size:12px;">
                            <strong>Parcel Size:</strong> ${property.parcelsize || property._area || "N/A"} sq ft
                        </p>
                        <p style="margin:4px 0; font-size:12px;">
                            <strong>Zoning:</strong> ${property.zoning || property.ZonedCodeLocal || "N/A"}
                        </p>
                        ${property.zestimate ? `
                            <p style="margin:4px 0; font-size:12px;">
                                <strong>Zestimate:</strong> ${formatCurrency(property.zestimate)}
                            </p>
                        ` : ''}
                    </div>
                `)
                .addTo(mapRef.current);
            
            console.log("Popup added to map"); // ✅ ADD: Debug log
        },
        
        getMap: () => mapRef.current,
    };
}, []); // ✅ Make sure dependency array is present

  // ✅ EXPOSE flyToLocation method to parent component
//  useImperativeHandle(ref, () => ({
//     flyToLocation: (lng, lat, property) => {
//       if (!mapRef.current) {
//         console.warn("Map not initialized");
//         return;
//       }

//       // Close existing popups
//       if (popupRef.current) {
//         popupRef.current.remove();
//         popupRef.current = null;
//       }

//       const existingPopups = document.getElementsByClassName('mapboxgl-popup');
//       if (existingPopups.length) {
//         Array.from(existingPopups).forEach(popup => popup.remove());
//       }

//       // Fly to location
//       mapRef.current.flyTo({
//         center: [lng, lat],
//         zoom: 17,
//         essential: true,
//         duration: 1500,
//         pitch: 0,
//       });

//       // Show popup
//       const formatCurrency = (num) => num ? "$" + num.toLocaleString("en-US") : "N/A";

//       popupRef.current = new mapboxgl.Popup({ 
//         closeButton: true, 
//         closeOnClick: true,
//         offset: 25 
//       })
//         .setLngLat([lng, lat])
//         .setHTML(`
//           <div style="
//             background:#fff;
//             padding:14px;
//             border-radius:8px;
//             box-shadow:0 2px 8px rgba(0,0,0,0.15);
//             font-family:Inter, sans-serif;
//             font-size:13px;
//             width:280px;
//           ">
//             <h3 style="margin:0 0 8px 0; color:#1565C0; font-size:15px; font-weight:600;">
//               ${property.addrline1 || property.address || "N/A"}
//             </h3>
//             <hr style="border:none; border-top:1px solid #eee; margin:8px 0;">
//             <p style="margin:4px 0; font-size:12px;">
//               <strong>Location:</strong> ${property.city || "N/A"}, ${property.county || "N/A"}, ${property.state || "N/A"} ${property.zip5 || ""}
//             </p>
//             <p style="margin:4px 0; font-size:12px;">
//               <strong>Flood Risk:</strong> ${property._floodRisk || property.FloodFemaRisk || property.FloodRisk || "N/A"}
//             </p>
//             <p style="margin:4px 0; font-size:12px;">
//               <strong>Parcel Size:</strong> ${property.parcelsize || property._area || "N/A"} sq ft
//             </p>
//             <p style="margin:4px 0; font-size:12px;">
//               <strong>Zoning:</strong> ${property.zoning || property.ZonedCodeLocal || "N/A"}
//             </p>
//             ${property.zestimate ? `
//               <p style="margin:4px 0; font-size:12px;">
//                 <strong>Zestimate:</strong> ${formatCurrency(property.zestimate)}
//               </p>
//             ` : ''}
//           </div>
//         `)
//         .addTo(mapRef.current);
//     }
//   }));

  // Helper: Normalize features (derive lon/lat from geometry if missing)
  const normalizeFeatures = (features = []) =>
    features.map((f) => {
      const copy = { ...f, properties: { ...(f.properties || {}) } };
      const p = copy.properties;
      if (p.longitude !== undefined) p.longitude = Number(p.longitude);
      if (p.latitude !== undefined) p.latitude = Number(p.latitude);

      if ((p.longitude === undefined || isNaN(p.longitude)) || (p.latitude === undefined || isNaN(p.latitude))) {
        if (copy.geometry && copy.geometry.type === "Point" && Array.isArray(copy.geometry.coordinates)) {
          p.longitude = Number(copy.geometry.coordinates[0]);
          p.latitude = Number(copy.geometry.coordinates[1]);
        } else if (copy.geometry && (copy.geometry.type === "Polygon" || copy.geometry.type === "MultiPolygon") && Array.isArray(copy.geometry.coordinates)) {
          // simple centroid fallback: average first ring coordinates
          let ring;
          try {
            if (copy.geometry.type === "Polygon") ring = copy.geometry.coordinates[0];
            else if (copy.geometry.type === "MultiPolygon") ring = copy.geometry.coordinates[0]?.[0];
          } catch (e) {
            ring = null;
          }
          if (ring && ring.length) {
            const avg = ring.reduce((acc, c) => {
              acc[0] += Number(c[0]) || 0;
              acc[1] += Number(c[1]) || 0;
              return acc;
            }, [0, 0]);
            p.longitude = avg[0] / ring.length;
            p.latitude = avg[1] / ring.length;
          }
        }
      }
      return copy;
    });



  // init map once
  useEffect(() => {
    if (mapRef.current) return;

    mapRef.current = new mapboxgl.Map({
      container: containerRef.current,
      style: "mapbox://styles/mapbox/light-v11",
      center: [-82.5929, 28.8917],
      zoom: 14,
    });
    mapRef.current.addControl(new mapboxgl.NavigationControl(), "bottom-right");

    const ensureSourcesAndLayers = async (features, currentShowPoints) => {
      // prepare point features from properties or point geometry
      const pts = (features || [])
        .map((f) => {
          const lonRaw = f.properties?.longitude ?? f.properties?.lon ?? f.properties?.lng;
          const latRaw = f.properties?.latitude ?? f.properties?.lat ?? f.properties?.lat_y;
          const lon = lonRaw !== undefined ? Number(lonRaw) : NaN;
          const lat = latRaw !== undefined ? Number(latRaw) : NaN;
          if (!isNaN(lon) && !isNaN(lat)) {
            return {
              type: "Feature",
              geometry: { type: "Point", coordinates: [lon, lat] },
              properties: { ...(f.properties || {}), longitude: lon, latitude: lat },
            };
          }
          return null;
        })
        .filter(Boolean);

            // --- Add the second GeoJSON polygon layer ---
        const geoUrls = [
          "/assets/parcel/fema-flood-hazard-areas-12075-not-x.geojson",
          "/assets/parcel/fema-flood-hazard-areas-12017-not-x.geojson",
          
        ];
        const allFeatures = [];

        // Fetch and merge all geojson files
        for (const url of geoUrls) {
          const res = await fetch(url);
          const data = await res.json();
          allFeatures.push(...data.features);
        }

        const mergedData = {
          type: "FeatureCollection",
          features: allFeatures,
        };

        // Add or update source
        if (!mapRef.current.getSource("merged-zones")) {
          mapRef.current.addSource("merged-zones", {
            type: "geojson",
            data: mergedData,
          });
        } else {
          mapRef.current.getSource("merged-zones").setData(mergedData);
        }

        // Fill layer with zone-type-based color
        if (!mapRef.current.getLayer("zones-fill")) {
          mapRef.current.addLayer({
            id: "zones-fill",
            type: "fill",
            source: "merged-zones",
            paint: {
              "fill-opacity": 0.2,
              "fill-color": [
                "match",
                ["get", "zonetype"], // <-- Make sure this property exists in your GeoJSON

                "X", "#4CAF50",
                "AE", "#FF9800",
                "VE", "#E91E63",
                "A", "#2196F3",

          /* default */ "#9E9E9E"
              ],
            },
          });
        }

      // add or update parcel-source (polygons & all features)
      if (!mapRef.current.getSource("parcel-source")) {
        mapRef.current.addSource("parcel-source", { type: "geojson", data: { type: "FeatureCollection", features } });
      } else {
        mapRef.current.getSource("parcel-source").setData({ type: "FeatureCollection", features });
      }

      // add or update parcel-points source
      if (!mapRef.current.getSource("parcel-points")) {
        mapRef.current.addSource("parcel-points", { type: "geojson", data: { type: "FeatureCollection", features: pts } });
      } else {
        mapRef.current.getSource("parcel-points").setData({ type: "FeatureCollection", features: pts });
      }

      // add polygon fill layer
      if (!mapRef.current.getLayer("parcel-fill")) {
        mapRef.current.addLayer({
          id: "parcel-fill",
          type: "fill",
          source: "parcel-source",
          layout: { visibility: currentShowPoints ? "none" : "visible" },
          paint: { "fill-color": "#4CAF50", "fill-opacity": 0.45 },
        });
      } else {
        mapRef.current.setLayoutProperty("parcel-fill", "visibility", currentShowPoints ? "none" : "visible");
      }

      // add outline
      if (!mapRef.current.getLayer("parcel-outline")) {
        mapRef.current.addLayer({
          id: "parcel-outline",
          type: "line",
          source: "parcel-source",
          layout: { visibility: currentShowPoints ? "none" : "visible" },
          paint: { "line-color": "#2E7D32", "line-width": 1.3 },
        });
      } else {
        mapRef.current.setLayoutProperty("parcel-outline", "visibility", currentShowPoints ? "none" : "visible");
      }

      // add points layer
      if (!mapRef.current.getLayer("parcel-points-layer")) {
        mapRef.current.addLayer({
          id: "parcel-points-layer",
          type: "circle",
          source: "parcel-points",
          layout: { visibility: currentShowPoints ? "visible" : "none" },
          paint: { "circle-radius": 8, "circle-color": "#2E7D32", "circle-stroke-width": 1, "circle-stroke-color": "#fff" },
        });
      } else {
        mapRef.current.setLayoutProperty("parcel-points-layer", "visibility", currentShowPoints ? "visible" : "none");
      }
    };

    mapRef.current.on("load", async () => {
      try {
        // prefer parcels prop; fallback to fetching parcelFile
        let features = Array.isArray(parcels) && parcels.length ? parcels : null;
        if (!features) {
          const res = await fetch(parcelFile);
          const json = await res.json();
          features = (json.features || []).map((f) => ({ ...f, properties: { ...(f.properties || {}) } }));
        }
        features = normalizeFeatures(features || []);

        // ensureSourcesAndLayers(features, showPoints);
         ensureSourcesAndLayers(features, false);
        onLoaded(features);

        // add toggle control (class-based control)
        const toggle = new MapViewToggleControl(
          () => {
            // show polygons
            setShowPoints(false);
            try {
              if (mapRef.current.getLayer("parcel-fill")) mapRef.current.setLayoutProperty("parcel-fill", "visibility", "visible");
              if (mapRef.current.getLayer("parcel-outline")) mapRef.current.setLayoutProperty("parcel-outline", "visibility", "visible");
              if (mapRef.current.getLayer("parcel-points-layer")) mapRef.current.setLayoutProperty("parcel-points-layer", "visibility", "none");
            } catch (e) {}
          },
          () => {
            // show points
            setShowPoints(true);
            try {
              if (mapRef.current.getLayer("parcel-fill")) mapRef.current.setLayoutProperty("parcel-fill", "visibility", "none");
              if (mapRef.current.getLayer("parcel-outline")) mapRef.current.setLayoutProperty("parcel-outline", "visibility", "none");
              if (mapRef.current.getLayer("parcel-points-layer")) mapRef.current.setLayoutProperty("parcel-points-layer", "visibility", "visible");
            } catch (e) {}
          },
          // showPoints
            false
        );

        mapRef.current.addControl(toggle, "top-left");
        toggleRef.current = toggle;

      // ensure polygon layers visible and points hidden (default to polygon view)
        try {
          if (mapRef.current.getLayer("parcel-fill")) mapRef.current.setLayoutProperty("parcel-fill", "visibility", "visible");
          if (mapRef.current.getLayer("parcel-outline")) mapRef.current.setLayoutProperty("parcel-outline", "visibility", "visible");
          if (mapRef.current.getLayer("parcel-points-layer")) mapRef.current.setLayoutProperty("parcel-points-layer", "visibility", "none");
       } catch (e) { /* ignore if layers not ready */ }
       // update internal state control visuals
        setShowPoints(false);
        try { if (typeof toggle.update === "function") toggle.update(false); } catch (e) { }

        // click handlers
        mapRef.current.on("click", "parcel-points-layer", (e) => {
          const feat = (e.features && e.features[0]) || mapRef.current.queryRenderedFeatures(e.point, { layers: ["parcel-points-layer"] })[0];
          if (feat) {
            if (popupRef.current) popupRef.current.remove();
            popupRef.current = new mapboxgl.Popup().setLngLat(feat.geometry.coordinates).setHTML(makePopupHTML(feat.properties)).addTo(mapRef.current);
            onFeatureClick(feat);
          }
        });

        mapRef.current.on("click", "parcel-fill", (e) => {
          const feat = (e.features && e.features[0]) || mapRef.current.queryRenderedFeatures(e.point, { layers: ["parcel-fill"] })[0];
          if (feat) {
            const lngLat = e.lngLat || (feat.geometry && feat.geometry.coordinates && feat.geometry.coordinates[0] && feat.geometry.coordinates[0][0]) || null;
            if (popupRef.current) popupRef.current.remove();
            if (lngLat) popupRef.current = new mapboxgl.Popup().setLngLat(e.lngLat).setHTML(makePopupHTML(feat.properties)).addTo(mapRef.current);
            onFeatureClick(feat);
          }
        });

        ["parcel-points-layer", "parcel-fill"].forEach((layerId) => {
          mapRef.current.on("mouseenter", layerId, () => (mapRef.current.getCanvas().style.cursor = "pointer"));
          mapRef.current.on("mouseleave", layerId, () => (mapRef.current.getCanvas().style.cursor = ""));
        });

        // fit bounds if coordinates available
        const coords = features.flatMap((f) =>
          typeof f.properties?.longitude === "number" && typeof f.properties?.latitude === "number" ? [[f.properties.longitude, f.properties.latitude]] : []
        );
        // if (coords.length) {
        //   const lats = coords.map((c) => c[1]);
        //   const lons = coords.map((c) => c[0]);
        //   const sw = [Math.min(...lons), Math.min(...lats)];
        //   const ne = [Math.max(...lons), Math.max(...lats)];
        //   mapRef.current.fitBounds([sw, ne], { padding: 48, maxZoom: 14 });
        // }
      } catch (err) {
        console.error("ParcelMap load error", err);
      }
    });

    return () => {
      if (mapRef.current) {
        try {
          mapRef.current.remove();
        } catch (e) {}
        mapRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parcelFile]);

  // update when parcels or showPoints change
  useEffect(() => {
    if (!mapRef.current) return;
    try {
      const features = normalizeFeatures(Array.isArray(parcels) ? parcels : []);
      // update or add sources
      if (mapRef.current.getSource("parcel-source")) {
        mapRef.current.getSource("parcel-source").setData({ type: "FeatureCollection", features });
      } else {
        mapRef.current.addSource("parcel-source", { type: "geojson", data: { type: "FeatureCollection", features } });
      }

      const pts = features
        .map((f) => {
          const lon = Number(f.properties?.longitude);
          const lat = Number(f.properties?.latitude);
          if (!isNaN(lon) && !isNaN(lat)) return { type: "Feature", geometry: { type: "Point", coordinates: [lon, lat] }, properties: f.properties || {} };
          return null;
        })
        .filter(Boolean);

      if (mapRef.current.getSource("parcel-points")) {
        mapRef.current.getSource("parcel-points").setData({ type: "FeatureCollection", features: pts });
      } else {
        mapRef.current.addSource("parcel-points", { type: "geojson", data: { type: "FeatureCollection", features: pts } });
      }

      // ensure layers exist
      if (!mapRef.current.getLayer("parcel-fill")) {
        mapRef.current.addLayer({ id: "parcel-fill", type: "fill", source: "parcel-source", paint: { "fill-color": "#4CAF50", "fill-opacity": 0.45 } });
      }
      if (!mapRef.current.getLayer("parcel-outline")) {
        mapRef.current.addLayer({ id: "parcel-outline", type: "line", source: "parcel-source", paint: { "line-color": "#2E7D32", "line-width": 1.3 } });
      }
      if (!mapRef.current.getLayer("parcel-points-layer")) {
        mapRef.current.addLayer({ id: "parcel-points-layer", type: "circle", source: "parcel-points", paint: { "circle-radius": 8, "circle-color": "#2E7D32", "circle-stroke-width": 1, "circle-stroke-color": "#fff" } });
      }

      // set visibility according to showPoints
      try {
        mapRef.current.setLayoutProperty("parcel-fill", "visibility", showPoints ? "none" : "visible");
        mapRef.current.setLayoutProperty("parcel-outline", "visibility", showPoints ? "none" : "visible");
        mapRef.current.setLayoutProperty("parcel-points-layer", "visibility", showPoints ? "visible" : "none");
      } catch (e) {}

      // update toggle control UI
      setTimeout(() => {
        try {
          toggleRef.current && toggleRef.current.update && toggleRef.current.update(showPoints);
        } catch (e) {}
      }, 50);
    } catch (e) {
      console.error("ParcelMap update error:", e);
    }
  }, [parcels, showPoints]);

  // flyTo selected feature
  useEffect(() => {
    if (!selectedFeature || !mapRef.current) return;
    const coords =
      (selectedFeature.geometry && selectedFeature.geometry.type === "Point" && selectedFeature.geometry.coordinates) ||
      (selectedFeature.properties && [selectedFeature.properties.longitude, selectedFeature.properties.latitude]) ||
      null;
    if (coords && Array.isArray(coords)) {
      try {
        mapRef.current.flyTo({ center: coords, zoom: 15 });
      } catch (e) {}
    }
  }, [selectedFeature]);

  function makePopupHTML(props = {}) {
    return `
      <div style="background:#fff;padding:12px;border-radius:8px;font-size:13px;width:260px;">
        <h4 style="margin:0 0 6px 0;color:#1565C0">${props.addrline1 || props.address || "N/A"}</h4>
        <div style="font-size:12px;color:#333">
          <div><strong>Flood:</strong> ${props._floodRisk || props.FloodRisk || "N/A"}</div>
          <div><strong>Parcel Size:</strong> ${props._area ? Number(props._area).toLocaleString() + " sq ft" : (props.AreaBuilding ? props.AreaBuilding + " sq ft" : "N/A")}</div>
          <div><strong>Zoning:</strong> ${props._zone || props.ZonedCodeLocal || props.ZoneCode || "N/A"}</div>
        </div>
      </div>
    `;
  }

  return <div ref={containerRef} style={{ width: "100%", height: "100%" }} />;
});

export default ParcelMap;